import React from "react";
import MiniDrawer from "./Drawer/Menu/Menu";
import AppRoutes from "./Drawer/Routes";
import { AppBar, Box } from "@mui/material";
import MainLayout from "./Pages/Main";
import { BASENAME } from "./config";
import { BrowserRouter } from "react-router-dom";
import LoginProvider from "./Pages/Login/LoginProvider";
import withAppProviders from "./withAppProviders";

const App: React.FC = () => {

  // const currentPath = window.location.href;
  
  // // Define routes where sidebar should be hidden
  // const noSidebarRoutes = ['/sales'];

  // // Check if the current URL matches any defined route for no sidebar
  // const hideSidebar = noSidebarRoutes.some(route => currentPath.includes(route));

  return (
  <Box data-testid="pos-ui-app">
    <MainLayout>
      <BrowserRouter basename={BASENAME}>
        <LoginProvider>
          <Box>
            {/* {hideSidebar ?  <AppRoutes /> */}
            {/* : */}
             <MiniDrawer>
            <AppRoutes />
          </MiniDrawer>
            {/* } */}
           
          </Box>
        </LoginProvider>
      </BrowserRouter>
    </MainLayout>
  </Box>
  )
};

export default withAppProviders(App);
